import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGame } from '../types';


const initialState: IGame = {
  gameId: -1,
  gameInfo: {},
  rewards: {},
  userSizeRewards: [],
  userEvenRewards: [],
  hotGameRewards: []
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    postGameId: (state, action: PayloadAction<{gameId: any}>) => {
      state.gameId = action.payload.gameId;
    },
    postGameInfo: (state, action: PayloadAction<{gameInfo: any}>) => {
      state.gameInfo = action.payload.gameInfo;
    },
    postRewards: (state, action: PayloadAction<{rewards: any}>) => {
      state.rewards = action.payload.rewards;
    },
    postSizeRewards: (state, action: PayloadAction<{rewards: any}>) => {
      state.userSizeRewards = action.payload.rewards;
    },
    postEvenRewards: (state, action: PayloadAction<{rewards: any}>) => {
      state.userEvenRewards = action.payload.rewards;
    },
    postHotRewards: (state, action: PayloadAction<{rewards: any}>) => {
      state.hotGameRewards = action.payload.rewards;
    },
  }
});

export const { postGameId, postGameInfo, postRewards, postSizeRewards, postEvenRewards, postHotRewards  } = gameSlice.actions;

export default gameSlice;